import React from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import useMediaQuery from "../../../hooks/useMediaQuery"
import { VFC } from "react"
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image"
import { getBgImage, getBgWavePc, getBgWaveSp, Target } from "../../../utils"

type Props = {
  items: {
    title: string
    image: IGatsbyImageData
  }[]
  target: Target
}

const SliderSlick: VFC<Props> = ({ items, target }) => {
  const isPC = useMediaQuery("(min-width: 768px)")
  const settings = {
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 1500,
    dots: true,
    arrows: false,
    centerMode: isPC ? true : false,
    centerPadding: isPC ? "20%" : "0%",
    slidesToShow: 1,
  }

  return (
    <div
      style={{
        margin: `45px calc(50% - 50vw + 8px) 0`,
      }}
    >
      <div className={`pb-16 -mt-10 md:-mt-12 text-center ${getBgImage(target)}`}>
        <Slider {...settings}>
          {items &&
            items.map(item => {
              return (
                <div key={item.title} className="px-4">
                  <GatsbyImage
                    image={item.image}
                    alt=""
                    className="text-xl font-semibold tracking-tight rounded-md h-80 md:h-auto"
                  />
                </div>
              )
            })}
        </Slider>
      </div>
      <div
        className={`h-4 rotate-180 bg-repeat-x md:h-8 ${getBgWaveSp(
          target
        )} ${getBgWavePc(target)}`}
      ></div>
    </div>
  )
}

export default SliderSlick
